import { Radio } from 'flowbite-react';
import React from 'react';
import { Img } from 'react-image';

interface Props {
	isSelected: boolean;
	label: string;
	handleSelect: (arg: string) => void;
}

const ClosePositionOptionElement = ({ isSelected, label, handleSelect }: Props) => {
	return (
		<>
			<div
				onClick={() => handleSelect(label)}
				className="p-3 cursor-pointer rounded-[8px] dark:text-white bg-[#f2f2f2] dark:bg-[#4B5563] flex gap-3 items-center"
			>
				<Radio className="text-[#7777E7] focus:ring-[#7777E7]" color="purplePlaced" checked={isSelected} />

				<div>{label}</div>
			</div>
		</>
	);
};

export default ClosePositionOptionElement;
